/**
 * Save files to storage, then add file urls to corresponding product
 * @param {*} firebase Firebase object containing storage functions
 * @param {*} imagesPath Storage path where images have to be stored
 * @param {*} fileArray Array containing the id's of the files to delete
 * @param {*} imageUrlArray Array of urls that get linked to product
 * @param {*} documentId ID of the product that needs to be updated
 * @returns
 */
import { FIRESTORE_PRODUCTS_TABLE } from "../../constants/FirestoreConstant";

export const saveFilesToStorage = (firebase, imagesPath, fileArray, imageUrlArray, documentId) => {
  return new Promise((resolve, reject) => {
    firebase
      .uploadFiles(imagesPath, fileArray, imagesPath, {
        name: function (file) {
          return file.uid;
        },
        metadataFactory: (uploadRes, firebase, metadata, downloadUrl) => {
          // Push the downloadUrl to the existing files array
          imageUrlArray.push(downloadUrl);
          return { image: imageUrlArray };
        },
        // Add the updated files array to our product image array
        documentId: documentId,
      })
      .then(() => {
        resolve();
      })
      .catch((error) => reject(error));
  });
};

/**
 * Save purchase order images to storage
 * @param {*} firebase Firebase object containing storage functions
 * @param {*} purchaseOrderId ID of the purchase order
 * @param {*} fileArray Array of files to upload
 * @returns Promise with array of download URLs
 */
export const savePurchaseOrderImagesToStorage = (firebase, purchaseOrderId, fileArray) => {
  return new Promise((resolve, reject) => {
    const uploadPromises = fileArray.map((file) => {
      const storageRef = firebase.storage().ref(`purchaseOrders/${purchaseOrderId}/images/${file.uid}`);

      return storageRef.put(file.originFileObj).then((snapshot) => {
        return snapshot.ref.getDownloadURL();
      });
    });

    Promise.all(uploadPromises)
      .then((downloadUrls) => resolve(downloadUrls))
      .catch((error) => reject(error));
  });
};

/**
 * Delete files from storage, then remove file urls from corresponding product
 * @param {*} firebase Firebase object containing storage functions
 * @param {*} firestore Firestore object containing firestore functions
 * @param {*} fileArray Array containing the id's of the files to delete
 * @param {*} productId ID of the product that needs to be updated
 * @param {*} urlArray Array containing urls that have to be removed from product
 */
export const deleteFilesFromStorage = (firebase, firestore, fileArray, productId, urlArray) => {
  fileArray.forEach((item) => {
    firebase.deleteFile(item).catch((error) => console.error(error));
  });
  // Remove url from image array
  firestore
    .collection(FIRESTORE_PRODUCTS_TABLE)
    .doc(productId)
    .update({
      image: firebase.firestore.FieldValue.arrayRemove(...urlArray),
    })
    .catch((error) => console.error(error));
};

/**
 * USED WHEN DELETING ENTIRE PRODUCTS
 * Delete all associated files from storage when deleting a product
 * @param {*} firebase Firebase object containing storage functions
 * @param {*} images Array of images (storage urls) that have to be deleted from storage
 */
export const deleteAssociatedFilesFromStorage = (firebase, images) => {
  if (!!images) {
    images.forEach((item) => {
      let fileRef = firebase.storage().refFromURL(item);
      fileRef.delete().catch((error) => console.log(error));
    });
  }
};
